<fieldset class="group">
    <legend>{{ "FLIGHT_LIST.groups.fuel" | translate }}</legend>
    <app-fuel-row [group]="group()" [fields]="fields" [units]="units()" [maxTank]="maxTank()"></app-fuel-row>
</fieldset>
